import { render } from "./InterconsultaDestinoForm.vue?vue&type=template&id=1f0ca3ef&scoped=true"
import script from "./InterconsultaDestinoForm.vue?vue&type=script&lang=js"
export * from "./InterconsultaDestinoForm.vue?vue&type=script&lang=js"

import "@/assets/css/tabs.css?vue&type=style&index=0&id=1f0ca3ef&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f0ca3ef"]])

export default __exports__